import { DASHBOARD_WORKBOARD_SLUG } from 'dashboard409a/common/constants';
import {
  readTabSessionValue,
  removeTabSessionValue,
  writeTabSessionValue,
} from 'services/storage/tabSessionStorage';

const WORKBOARD_PREVIOUS_ROUTE_KEY = 'workboard_previous_route';

const workboardRouteStorageKey = (userId: number): string =>
  `${WORKBOARD_PREVIOUS_ROUTE_KEY}_${userId}`;

const isSafeWorkboardRoute = (route: string): boolean => {
  const pathOnly = route.split('?')[0] ?? '';

  return pathOnly.startsWith(`${DASHBOARD_WORKBOARD_SLUG}/`) && !pathOnly.startsWith('//');
};

/**
 * Gets the workboard route saved by this browser tab.
 * @returns The saved route or null if none exists
 */
export const getPreviousWorkboardRoute = (userId?: number): string | null => {
  if (globalThis.window) {
    // The legacy key had no user scope, so it cannot be safely attributed after sign-in.
    removeTabSessionValue(WORKBOARD_PREVIOUS_ROUTE_KEY);

    if (!userId) {
      return null;
    }

    const storageKey = workboardRouteStorageKey(userId);
    const route = readTabSessionValue(storageKey);

    if (route && isSafeWorkboardRoute(route)) {
      return route;
    }

    removeTabSessionValue(storageKey);
  }
  return null;
};

/**
 * Clears the previously saved workboard route.
 */
export const clearPreviousWorkboardRoute = (userId?: number): void => {
  if (globalThis.window) {
    if (userId) {
      removeTabSessionValue(workboardRouteStorageKey(userId));
    }
    removeTabSessionValue(WORKBOARD_PREVIOUS_ROUTE_KEY);
  }
};

/**
 * Saves the current workboard route for this browser tab.
 * @param route - The workboard route to save
 */
export const savePreviousWorkboardRoute = (route: string, userId?: number): void => {
  if (globalThis.window && userId && isSafeWorkboardRoute(route)) {
    writeTabSessionValue(workboardRouteStorageKey(userId), route);
  }
};
